export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500/10 via-accent-500/10 to-primary-500/5 rounded-3xl p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                随时随地 · 追剧不停
              </h2>
              <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                极速影视全面适配手机与平板，无论你是在通勤路上还是周末宅家，打开手机就能畅享最新电影和热播电视剧全集，高清画质流畅不卡顿，让你随时随地追剧畅快淋漓。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg font-medium text-sm cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 版下载
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg font-medium text-sm cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 版下载
                </a>
              </div>
            </div>
            <div className="flex-shrink-0 w-48 md:w-56">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20movie%20streaming%20app%20interface%20with%20warm%20cinema%20theme%2C%20dark%20background%2C%20golden%20and%20crimson%20accent%20colors%2C%20clean%20modern%20UI%2C%20film%20poster%20thumbnails%2C%20elegant%20mobile%20app%20design%2C%20no%20real%20text&width=400&height=700&seq=app-phone-2026-01&orientation=portrait"
                alt="极速影视移动端追剧体验"
                className="w-full h-auto rounded-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}